function sendGA_entry(val) {
  if (typeof ga !== "undefined" && !(val.medium == "" && val.source == "")) {
    ga("gtm1.send", "event", val.medium, "入会", val.source);
    return true;
  }
  return false;
}

$(function () {
  if ($(".entry.create #affiliates").length < 1) return;

  var values = {
    source: $("#source").text(),
    medium: $("#medium").text(),
  };

  if (!sendGA_entry(values)) {
    setTimeout(function () {
      sendGA_entry(values);
    }, 1200);
  }
});
